// extracted by mini-css-extract-plugin
export default {"terms-of-use":"TermsOfUse_terms-of-use__+dHac","banner-heading":"TermsOfUse_banner-heading__oBRbu"};